import Api from "./Api"
import { configStore, loginStore } from "./CommonState";
import Utils from "../util/Utils"
import { enquiryStore } from "../enquiry/enquiry-data";
const MONGO = {
    FIND: (collection) => `${process.env.REACT_APP_API_SERVER}/api/v1/mongo/find/${collection}`,
    AGGREGATE: (collection) => `${process.env.REACT_APP_API_SERVER}/api/v1/mongo/aggregate/${collection}`,
    INSERTONE: (collection) => `${process.env.REACT_APP_API_SERVER}/api/v1/mongo/insertone/${collection}`,
    REPLACEONE: (collection) => `${process.env.REACT_APP_API_SERVER}/api/v1/mongo/replaceone/${collection}`,
    UPDATEONE: (collection) => `${process.env.REACT_APP_API_SERVER}/api/v1/mongo/updateone/${collection}`,
    REMOVE: (collection) => `${process.env.REACT_APP_API_SERVER}/api/v1/mongo/remove/${collection}`,
    NEXTNUM: `${process.env.REACT_APP_API_SERVER}/api/v1/mongo/nextnum`,
}


// ==================== MONGO API URI CONSTANTS ====================
export const GET_AGUSERS_WITHOUT_CONTENT_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/aguser/getAgusersWithoutContent`;
export const GET_CENTRAL_OPERATIONS_AGUSERS_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/aguser/getCentralOperationsAgusers`;
export const GET_BOOKINGS_IDS_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/getBookingsIds`;
export const GET_BOOKINGS_LIST_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/getBookingsList`;
export const UPDATE_BOOKING_CANCELLED_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/updateBookingCancelled`;
export const UPDATE_BOOKING_BY_ID_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/updateBookingById`;
export const UPDATE_BOOKING_FIELDS_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/updateBookingFields`;
export const UPDATE_BOOKING_DATA_BY_ID_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/updateBookingDataById`;
export const REPLACE_BOOKING_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/replaceBooking`;
export const CLEAR_BOOKING_AWB_DRAFT_LIST_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/clearBookingAwbDraftList`;
export const CLEAR_BOOKING_CARRIER_RELEASE_ORDER_LIST_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/clearBookingCarrierReleaseOrderList`;
export const CLEAR_BOOKING_MEASUREMENT_SLIP_LIST_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/clearBookingMeasurementSlipList`;
export const CLEAR_BOOKING_POD_LIST_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/clearBookingPodList`;
export const CLEAR_BOOKING_BL_DRAFT_LIST_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/clearBookingBlDraftList`;
export const CLEAR_BOOKING_SHIPPING_INSTRUCTION_LIST_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/clearBookingShippingInstructionList`;
export const CLEAR_BOOKING_COMMERCIAL_INVOICE_AND_PACKING_LIST_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/clearBookingCommercialInvoiceAndPackingList`;
export const GET_CARTING_ORDERS_WITHOUT_FILES_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/cartingorder/getCartingOrdersWithoutFiles`;
export const GET_CARTING_ORDERS_BY_FILTER_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/cartingorder/getCartingOrdersByFilter`;
export const GET_PENDING_MYACTIONS_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/common/getPendingMyactions`;
export const GET_MYACTIONS_UPDATE_COST_COMPLETED_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/common/getMyactionsUpdateCostCompleted`;
export const GET_MYACTIONS_APPROVAL_FOR_LOSS_PENDING_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/common/getMyactionsApprovalForLossPending`;
export const GET_MYACTIONS_PAYMENT_DETAILS_PENDING_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/common/getMyactionsPaymentDetailsPending`;
export const GET_MYACTIONS_MEASUREMENT_SLIP_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/common/getMyactionsMeasurementSlip`;
export const GET_MYACTIONS_INVOICE_ACCEPTANCE_DUTIES_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/common/getMyactionsInvoiceAcceptanceDuties`;
export const GET_MYACTIONS_RAISE_INVOICE_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/common/getMyactionsRaiseInvoice`;
export const GET_MYACTIONS_SHIPPING_INSTRUCTIONS_PENDING_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/common/getMyactionsShippingInstructionsPending`;
export const GET_MYACTIONS_LIST_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/common/getMyactionsList`;
export const UPDATE_MYACTION_RAISE_INVOICE_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/common/updateMyactionRaiseInvoice`;
export const UPDATE_MYACTION_BY_ID_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/common/updateMyactionById`;
export const INSERT_ONE_MYACTION_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/common/insertOneMyaction`;
export const REPLACE_MYACTION_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/common/replaceMyaction`;
export const REMOVE_MYACTIONS_BY_BOOKING_NUMBER_AND_STATUS_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/common/removeMyActionsByBookingNumberAndStatus`;
export const REMOVE_MYACTIONS_BY_ID_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/common/removeMyActionsByID`;
export const UPDATE_ENTITY_BY_ID_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/common/updateEntityById`;
export const GET_BOOKINGDSR_BY_FILTER_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/myactions/getBookingdsrByFilter`;
export const UPDATE_BOOKINGDSR_BY_ID_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/myactions/updateBookingdsrById`;
export const UPDATE_BOOKINGDSR_DATA_BY_ID_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/myactions/updateBookingdsrDataById`;
export const GET_SH_ENTITIES_BY_FILTER_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/stakeholder/getSHEntitiesByFilter`;
export const GET_SH_ENTITIES_SORTED_BY_NAME_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/stakeholder/getSHEntitiesSortedByName`;
export const GET_SH_ENTITIES_NAME_AND_ID_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/stakeholder/getSHEntitiesNameAndId`;
export const GET_SH_ENTITIES_IDS_ONLY_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/stakeholder/getSHEntitiesIdsOnly`;
export const GET_SH_BRANCHES_BY_FILTER_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/stakeholder/getSHBranchesByFilter`;
export const GET_FILESTORE_WITHOUT_CONTENT_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/filestore/getFilestoreWithoutContent`;
export const GET_ADDRESSDETAILS_BY_FILTER_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/location/getAddressdetailsByFilter`;
export const GET_WEBHOOKS_BY_FILTER_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/webhooks/getWebhooksByFilter`;
export const GET_ENQUIRIES_SUMMARY_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/enquiries/getEnquiriesSummary`;
export const UPDATE_ENQUIRY_BY_ID_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/enquiries/updateEnquiryById`;
export const INSERT_ONE_SCHEDULE_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/schedules/insertOneSchedule`;
export const UPDATE_QUOTE_BY_ID_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/quotes/updateQuoteById`;
export const UPDATE_CONTRACT_SHOW_DUMMY_SCHEDULE_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/contracts/updateContractShowDummySchedule`;
// =================================================================

export default class MonApi {

    static getHeaders(headers = {}) {
        let headerss = Api.H(headers);
        let token = localStorage.getItem("devicetoken");
        if (!token) {
            try {
                const saved = JSON.parse(localStorage.getItem("ag_userrec") || sessionStorage.getItem("ag_userrec") || "null");
                token = saved?.aguserRec?.token || "";
            } catch(e) {}
        }
        if (token) {
            headerss['Devicetoken'] = token;
            headerss['token'] = token;
            headerss['Authorization'] = `Bearer ${token}`;
        }
        if (loginStore.isClient() && (!configStore.currentSelectedEntity?.entityId || configStore.currentSelectedEntity.entityId.length === 0)) {
            headerss['Current-Entity'] = 'ALL';
        }
        return headerss;
    }

    static post(url, payload, success, error) {
        const requestOptions = {
            method: 'POST',
            headers: MonApi.getHeaders(),
            credentials: Utils.shouldSendCredentials(url) ? 'include' : 'omit',
            body: JSON.stringify(payload)
        };
        fetch(url, requestOptions)
            .then(res => res.json())
            .then(data => { (data.error) ? error(data.error) : success(data) })
            .catch(err => {
                console.log('POST Url: ' + url + ' Err=', err)
                error('' + err)
            })
    }
    static async apost(url, payload, method = 'POST') {
        let headerss = MonApi.getHeaders()
        const requestOptions = {
            method: method,
            headers: headerss,
            credentials: Utils.shouldSendCredentials(url) ? 'include' : 'omit',
            body: JSON.stringify(payload)
        }
        return await fetch(url, requestOptions)
            .then(res => res.json())
    }
    static async streamPricing(url, payload, setRoutes, method = 'POST', signal = null) {
        if (typeof method === 'object' && method !== null && 'aborted' in method) {
            signal = method;
            method = 'POST';
        }
        if (signal?.aborted) {
            return { aborted: true }
        }
        let response
        let headerss = MonApi.getHeaders()
        const requestOptions = {
            method: method,
            headers: headerss,
            credentials: Utils.shouldSendCredentials(url) ? 'include' : 'omit',
            body: JSON.stringify(payload),
            ...(signal ? { signal } : {})
        }
        try {
            response = await fetch(url, requestOptions)
            console.log('\n\n\t\tTHE NEW RESPONSE=', response)
            if (!response.body) return {}
            const reader = response.body.getReader();
            const decoder = new TextDecoder();
            let buffer = '';

            while (true) {
                if (signal?.aborted) {
                    reader.cancel();
                    break;
                }
                const { value, done } = await reader.read();
                console.log('Chunked reader=', value)
                if (done || signal?.aborted) break;

                // Decode the chunk and add it to the existing buffer
                buffer += decoder.decode(value, { stream: true });
                console.log('Chunked buffer = ', buffer)
                // Split buffer by newlines to find complete JSON objects
                const parts = buffer.split('\n');

                // The last part might be an incomplete JSON string, keep it in the buffer
                buffer = parts.pop();

                for (const part of parts) {
                    if (signal?.aborted) break;
                    if (part.trim()) {
                        console.log('\tPART TRIME =', part)
                        let newRow = JSON.parse(part);
                        // Incrementally update state as each row is parsed
                        console.log('Newrow = ', newRow)
                        newRow.dummyContract['entityId'] = enquiryStore.current.entityId
                        newRow.dummyContract['nomination'] = enquiryStore.current.nomination
                        newRow.dummyContract['salesperson'] = enquiryStore.current.salesperson
                        newRow.dummyContract['customerService'] = enquiryStore.current.customerService
                        newRow.dummyContract['entityName'] = enquiryStore.current.entityName
                        newRow.dummyContract['opal'] = enquiryStore.current.opal
                        newRow.dummyContract['dpal'] = enquiryStore.current.dpal
                        newRow.quote['entityId'] = enquiryStore.current.entityId
                        newRow.quote['nomination'] = enquiryStore.current.nomination
                        newRow.quote['salesperson'] = enquiryStore.current.salesperson
                        newRow.quote['customerService'] = enquiryStore.current.customerService
                        newRow.quote['entityName'] = enquiryStore.current.entityName
                        newRow.quote.quoteSummary['entityId'] = enquiryStore.current.entityId
                        newRow.quote.quoteData['entityId'] = enquiryStore.current.entityId
                        newRow.quote.quoteData['nomination'] = enquiryStore.current.nomination
                        newRow.quote.quoteData['salesperson'] = enquiryStore.current.salesperson
                        newRow.quote.quoteData['customerService'] = enquiryStore.current.customerService
                        newRow.quote.quoteData['entityName'] = enquiryStore.current.entityName
                        newRow.quote.quoteData['opal'] = enquiryStore.current.opal
                        newRow.quote.quoteData['dpal'] = enquiryStore.current.dpal
                        newRow = Utils.changeRetObject(newRow, enquiryStore)
                        setRoutes(prevRows => [...prevRows, newRow]);
                    }
                }
            }
            if (signal?.aborted) {
                return { aborted: true }
            }
            return {}
        } catch (error) {
            if (error.name === 'AbortError' || signal?.aborted) {
                console.log('Stream pricing aborted')
                return { aborted: true }
            }
            console.error('Error in streamPricing:', error)
            return { error: error.message || error }
        }
    }
    static async aposttext(url, payload, method = 'POST') {
        console.log('\n\n\nINSIDE APOST TEXT ******************')
        let headerss = MonApi.getHeaders()
        const requestOptions = {
            method: method,
            headers: headerss,
            credentials: Utils.shouldSendCredentials(url) ? 'include' : 'omit',
            body: JSON.stringify(payload)
        }
        let ret = await fetch(url, requestOptions).then(res => res.text())
        let result = []
        const parts = ret.split('\n');
        for (const part of parts) {
            if (part.trim()) {
                console.log('\tPART TRIME =', part)
                const newRow = JSON.parse(part);
                console.log('Newrow = ', newRow)
                result.push(newRow)
            }
        }
        return result
    }
    static aposttextOptions(url, payload, method = 'POST') {
        let headerss = MonApi.getHeaders()
        const requestOptions = {
            method: method,
            headers: headerss,
            credentials: Utils.shouldSendCredentials(url) ? 'include' : 'omit',
            body: JSON.stringify(payload)
        }
        return requestOptions
    }
    static async aget(url) {
        const requestOptions = {
            method: 'GET',
            headers: MonApi.getHeaders(),
            credentials: Utils.shouldSendCredentials(url) ? 'include' : 'omit',
        }
        return await fetch(url, requestOptions)
            .then(res => res.json())
    }
    static async get(url) {
        const requestOptions = {
            headers: MonApi.getHeaders(),
            credentials: Utils.shouldSendCredentials(url) ? 'include' : 'omit',
        }
        return await fetch(url, requestOptions).then(res => res.json())
    }
    static async nextnum(key) {
        return await MonApi.apost(MONGO.NEXTNUM, { key })
    }
}